import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const FavoritesIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 16 22" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Overrides/Icons/Bookmark"
          transform="translate(-4.000000, -2.000000)"
          stroke={color ? color : " #222222"}
          strokeWidth="2"
        >
          <g id="Path-2" transform="translate(5.500000, 3.000000)">
            <path
              d="M13,19.0520571 C13,20.0998155 12.4430958,20.3112721 11.7766671,19.5245009 L6.50278452,13.3370115 L1.22333286,19.5206908 C0.549478795,20.3093671 0,20.0921954 0,19.0501521 L0,1.90501521 C0,0.85290436 0.831114987,0 1.85634728,0 L11.1380837,0 C12.163316,0 12.994431,0.85290436 12.994431,1.90501521 L13,19.0520571 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
